export const GenericRegex = {
  noBlanks: /^\S/
};
